<main class="container-geral d-flex flex-column gap-4">
  <section class="cabecalho">
    <h1 class="titulo">
      {{ operacaoId
          ? ('COMPONENTS.CADASTRO_OPERACAO.titleUpdate' | transloco)
          : ('COMPONENTS.CADASTRO_OPERACAO.titleCreate' | transloco)
      }}
      {{ 'COMPONENTS.CADASTRO_OPERACAO.operation' | transloco }}
    </h1>
  </section>
  <section class="form-section">
    <p class="paragrafo-informacoes">{{ 'COMPONENTS.CADASTRO_OPERACAO.info' | transloco }}</p>
    <div class="formulario">
      <form class="group-form" [formGroup]="formularioOperacao" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label" for="numeroOrdemServico">{{ 'COMPONENTS.CADASTRO_OPERACAO.serviceOrderLabel' | transloco }}</label>
            <app-loading [linhas]=1 [colunas]=1 *ngIf="loading"></app-loading>
            <input *ngIf="!loading" id="numeroOrdemServico" formControlName="vc_service_id" type="text"
              class="input-form form-control" placeholder="{{ 'COMPONENTS.CADASTRO_OPERACAO.serviceOrderPlaceholder' | transloco }}"
              [class.invalido]="validarCampoInvalido(formularioOperacao.get('vc_service_id'))" />
            @if(validarCampoInvalido(formularioOperacao.get('vc_service_id'))) {
            <small class="mensagem-validacao-form">{{ 'COMPONENTS.CADASTRO_OPERACAO.serviceOrderRequired' | transloco }}</small>
            }
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label" for="usina">{{ 'COMPONENTS.CADASTRO_OPERACAO.plantLabel' | transloco }}</label>
            <app-loading [linhas]=1 [colunas]=1 *ngIf="loading"></app-loading>
            <select *ngIf="!loading" id="usina" formControlName="fk_cliente"
              class="crud-select form-select input-form form-control" (change)="buscarItensCliente()">
              <option value="" disabled>{{placeholderClientes}}</option>
              @for(cliente of clientes; track cliente.id) {
              <option [value]="cliente.id">{{cliente.nome}}</option>
              }
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label" for="status">{{ 'COMPONENTS.CADASTRO_OPERACAO.statusLabel' | transloco }}</label>
            <app-loading [linhas]=1 [colunas]=1 *ngIf="loading"></app-loading>
            <select *ngIf="!loading" id="status" formControlName="en_estado" class="crud-select form-select input-form">
              <option value="" disabled>
                {{ 'COMPONENTS.CADASTRO_OPERACAO.statusPlaceholder' | transloco }}
              </option>
              @for (estado of estados; track estado.dado) {
                <option [value]="estado.dado">
                  {{ 'ENUMS.operacao_status.' + estado.dado | transloco }}
                </option>
              }
            </select>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label" for="fazenda">{{ 'COMPONENTS.CADASTRO_OPERACAO.farmLabel' | transloco }}</label>
            <app-loading [linhas]=1 [colunas]=1 *ngIf="loadingFazendas || loading"></app-loading>
            <select *ngIf="!loadingFazendas" id="fazenda" formControlName="fk_fazenda"
              class="crud-select form-select input-form">
              <option value="" disabled>{{ 'COMPONENTS.CADASTRO_OPERACAO.farmPlaceholder' | transloco }}</option>
              <option *ngIf="!fazendas" value="" selected disabled>{{ 'COMPONENTS.CADASTRO_OPERACAO.noFarm' | transloco }}</option>
              <option *ngFor="let fazenda of fazendas" [value]="fazenda.sr_id">{{fazenda.vc_nome}}</option>
            </select>
          </div>
        </div>

        <div class='row'>
          <div class="col-md-6 mb-4">
            <label class="form-label" for="frentes">{{ 'COMPONENTS.CADASTRO_OPERACAO.frontsLabel' | transloco }}</label>
            <app-loading [linhas]=1 [colunas]=1 *ngIf="loadingFrentes"></app-loading>
            <mat-select *ngIf="!loadingFrentes" formControlName="ids_frentes" placeholder="{{ 'COMPONENTS.CADASTRO_OPERACAO.frontsSearch' | transloco }}"
              multiple panelClass="panel" class="crud-select form-select input-form">
              <mat-option class="d-none"></mat-option>
              <div class="container-filtro">
                <object class="icone-lupa" data="assets/icones-filtros/icone-lupa.svg" type="image/svg+xml"></object>
                <input (input)="filtrarSelect($event)" class="filtro-pesquisa color-input"
                  placeholder="{{ 'COMPONENTS.CADASTRO_OPERACAO.frontsSearch' | transloco }}" />
              </div>

              <div *ngIf="!frentes" class="w-100 d-flex mt-2">
                <span class="w-100 text-center">{{ 'COMPONENTS.CADASTRO_OPERACAO.noFronts' | transloco }}</span>
              </div>

              @for (frente of frentesFiltro; track frente.sr_id) {
              <mat-option [value]="frente.sr_id">{{ frente.vc_nome }}</mat-option>
              }
            </mat-select>
          </div>
        </div>
        <div class="buttons-form d-flex">
          <button type="button" (click)="cancelar()" class="btn-cancelar">
            <object class="me-2" data="assets/icone-fechar.svg" type="image/svg+xml"></object>
            {{ 'COMPONENTS.CADASTRO_OPERACAO.cancelButton' | transloco }}
          </button>
          <button type="submit" class="btn-confirmar" [disabled]="botaoDesabilitado"
            [class.btn-confirmar-desabilitado]="botaoDesabilitado">
            @if (loadingBotao) {
            <div class="spinner-border text-white spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            }@else{
            {{ operacaoId
                ? ('COMPONENTS.CADASTRO_OPERACAO.updateButton' | transloco)
                : ('COMPONENTS.CADASTRO_OPERACAO.createButton' | transloco)
            }}
            }
          </button>
        </div>
      </form>
    </div>
  </section>
</main>
